require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/app/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/app/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/app/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/app/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"last 5 versions\",\"Edge >= 12\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/app/node_modules/babel-preset-stage-0/lib/index.js\",\"/app/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./profile.js") })
        }
      }, "component---src-pages-profile-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-profile-js!./src/pages/profile.js
// module id = 286
// module chunks = 231608221292675